<ng-container *ngIf="loading">
    <div class="text-center my-6">
        <i class="fas fa-circle-notch fa-spin fa-3x spinner-color"></i>
    </div>
</ng-container>
